/**
 * Feature-discovery-specific colors.
 *
 * These lavender/yellow values are unique to the feature discovery surfaces and
 * are not part of the shared theme palette, so they live here to keep a single
 * source of truth across the tour modal and Help-panel entry cards (rather than
 * duplicating raw hex values).
 */
export const featureDiscoveryColors = {
  /** Shared "New" pill background. */
  badgeYellow: "#ffc845",
  /** Card + tooltip surface background. */
  lavenderSurface: "#f5ebff",
  /** Help-card hover background. */
  lavenderHover: "#efe2ff",
  /** Secondary-button hover tint. */
  lavenderTint: "#f7f4ff",
} as const;
